"use client";
import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./components/Header";
import LandingPage from "./views/LandingPage";
import { Routes, Route } from "react-router-dom";
import Individuals from "./views/Individuals";
import Pricing from "./views/Pricing";
import Industries from "./views/Industries";
import Business from "./views/Business";
import { ThemeProvider } from "./ThemeProvider";
import PartnerWithUs from "./views/PartnerWithUs";
import AboutUs from "./views/AboutUs";
import TermsOfUse from "./views/TermsOfUse";
import Contact from "./views/Contact";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicy from "./views/PrivacyPolicy";
import CookiePolicy from "./views/CookiePolicy";
import CodeOfConduct from "./views/CodeOfConduct";

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <CssBaseline />
      <div className="landing-page">
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/individuals" element={<Individuals/>} />
          <Route path="/individuals-pricing" element={<Pricing/>} />
          <Route path="/industries" element={<Industries/>} />
          <Route path="/business" element={<Business/>}/>
          <Route path="/partner" element={<PartnerWithUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy/>} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
};

export default App;
